import type { TableColumn } from '@/components/ccms-components/data-display/types';

// UI-chrome columns have nothing meaningful to put in a cell.
const NON_EXPORT_KEYS = new Set(['select', 'actions']);

function csvEscape(value: unknown): string {
  if (value === null || value === undefined) return '';
  const str = String(value);
  // Quote whenever the value contains the Excel delimiter, a quote, or newline.
  if (/[;"\n]/.test(str)) return `"${str.replace(/"/g, '""')}"`;
  return str;
}

/** Same output as ExportCsvButton (semicolon-separated, UTF-8 BOM, dated filename). */
export function downloadCsv<T>(rows: T[], columns: TableColumn<T>[], filename: string) {
  const exportable = columns.filter((c) => !NON_EXPORT_KEYS.has(c.key));

  const headerRow = exportable.map((c) => csvEscape(c.header || c.key));
  const bodyRows = rows.map((row) =>
    exportable.map((c) => {
      let value: unknown;
      if (c.exportAccessor) {
        value = c.exportAccessor(row);
      } else if (typeof c.accessor === 'function') {
        value = (c.accessor as (row: T) => unknown)(row);
      } else {
        value = (row as any)[c.accessor as keyof T];
      }
      return csvEscape(value);
    }),
  );

  const csv = [headerRow, ...bodyRows].map((r) => r.join(';')).join('\r\n');
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}